import { render, staticRenderFns } from "./temhead5.vue?vue&type=template&id=7348a26b&scoped=true"
import script from "./temhead5.vue?vue&type=script&lang=js"
export * from "./temhead5.vue?vue&type=script&lang=js"
import style0 from "./temhead5.vue?vue&type=style&index=0&id=7348a26b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7348a26b",
  null
  
)

export default component.exports